import { render, staticRenderFns } from "./GlassColor.vue?vue&type=template&id=13f5a622&"
import script from "./GlassColor.vue?vue&type=script&lang=js&"
export * from "./GlassColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports